export default __webpack_public_path__ + "static/media/pod3.6a8b1fbf.gif";